import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_BEASTS_OF_CHAOS: {
    name: 'Battletome: Beasts of Chaos (2023)',
    type: 'battletome',
  },
  ERRATA_APRIL_2023: {
    name: 'Errata (April 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2018/10/WotnUpw97M7nNtlG.pdf',
  },
} satisfies TRuleSources

export default rule_sources
